import Link from 'next/link';
import { useTranslation } from 'next-i18next';
import ImageWithText from '@features/cms/components/inspirations/InspirationPremiumIdeaBlock/ImageWithText/ImageWithText';
import Button from '@components/Button/Button';
import styles from '@features/cms/components/inspirations/InspirationPremiumIdeaBlock/InspirationPremiumIdeaBlock.styles';
import { useResponsive } from '@features/responsive';
import { ICmsDocument, IListingInspirationsBlock } from '@features/cms/typescript';
import { stripBrTags } from '@utils/splitTextByLineBreaks';
import ResponsiveImage from '@components/ResponsiveImage/ResponsiveImage';
type PropsType = {
  article: ICmsDocument;
  block: IListingInspirationsBlock;
  isInterior: boolean;
};
const InspirationPremiumIdeaBlock = ({
  article,
  block,
  isInterior
}: PropsType) => {
  const {
    baseData
  } = article;
  const leftImage = isInterior ? baseData?.image : baseData?.leftImage;
  const rightImage = isInterior ? baseData?.additionalImage : baseData?.rightImage;
  const {
    t
  } = useTranslation();
  const {
    isWiderThanTabletlg
  } = useResponsive();
  const articleTitle = stripBrTags(baseData?.name || '');
  return <section id={block.code} sx={styles.container(block?.background, block?.marginTop, block?.marginBottom)}>
      <div sx={styles.leftPart}>
        <ImageWithText title={articleTitle || ''} image={leftImage || ''}>
          {!isInterior && <p sx={styles.tag}>{baseData?.tags && Object.values(baseData.tags).map(tag => `#${tag} `)}</p>}
        </ImageWithText>
      </div>
      <div sx={styles.rightPart}>
        {(isInterior || isWiderThanTabletlg) && <div sx={styles.rightImgContainer}>
            {rightImage && <ResponsiveImage image={rightImage} alt={articleTitle || ''} />}
          </div>}
        <div sx={styles.content}>{baseData?.description || ''}</div>
        {isInterior ? <Link href="/pages/uslugi-projektowania">
            <Button variant="outlined" size="small" variantColor="dark">
              {t('button.orderFreeProject')}
            </Button>
          </Link> : <Link href={`/inspirations/ideas/${baseData?.slug}`}>
            <Button variant="outlined" size="small" variantColor="dark">
              {t('readMore')}
            </Button>
          </Link>}
      </div>
    </section>;
};
export default InspirationPremiumIdeaBlock;